import { render } from "./PreschoolPerformancesContent.vue?vue&type=template&id=015b4e71&ts=true"
import script from "./PreschoolPerformancesContent.vue?vue&type=script&lang=ts"
export * from "./PreschoolPerformancesContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__